import {
  FETCH_WISHLIST_SUCCESS,
  WISHLIST_ADD_REDUX,
  SET_WISHLIST_MODAL_STATE
} from "../types.js";

const initialState = {
  wishlist: [],
  modalOpen: false
};

const wishListReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_WISHLIST_MODAL_STATE:
      return {
        ...state,
        modalOpen: payload
      };
    case WISHLIST_ADD_REDUX:
      return {
        ...state,
        wishlist: payload
      };
    case FETCH_WISHLIST_SUCCESS:
      return {
        ...state,
        wishlist: { ...state.wishlist }
      };
    default:
      return state;
  }
};

export default wishListReducer;
